import { Box, styled } from '@mui/material';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';
import application from '../../../assest/img/1.png';
import banner from '../../../assest/img/banner22.png';
import applestore from '../../../assest/img/app-store.png';
import playstore from '../../../assest/img/app-play.png';

import './style.scss';

Refill.propTypes = {};

function Refill(props) {
    const { t } = useTranslation();
    const { ref, inView } = useInView({ threshold: 0.4, triggerOnce: true });
    return (
        <>
            <div className="support-button">
                <Container maxWidth="md">
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <div>
                                <a
                                    className="btn"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    href="https://faq.saisoncard.co.jp/?_gl=1*1huz3t6*_ga*NDQ1Njk3ODE2LjE2NTQ3NDU3MTM.*_ga_BKKP87CX6T*MTY1NjY1NTg1My4yOC4xLjE2NTY2NTY0OTUuNDg.#_ga=2.177591587.741013571.1656647561-445697816.1654745713"
                                >
                                    {t('support_value1')}
                                </a>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <div>
                                <a
                                    className="btn"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    href="https://www.saisoncard.co.jp/customer-support/counter-atm/"
                                >
                                    {t('support_value2')}
                                </a>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </div>
            <div className="download-section">
                <Container maxWidth="xl" ref={ref}>
                    <div className="download-container">
                        <div className="download-wrap">
                            <div className="download-content">
                                <h2 className="banner-text">
                                    <span>{t('application')}</span>
                                    <img src={banner} alt="banner" />
                                </h2>
                                <div className="download-banner">
                                    <a
                                        rel="noopener noreferrer"
                                        target="_blank"
                                        className="app-apple"
                                        href="https://apps.apple.com/jp/app/saisonportal/id896132217"
                                    >
                                        <img
                                            src={applestore}
                                            alt="apple store"
                                        />
                                    </a>
                                    <a
                                        rel="noopener noreferrer"
                                        target="_blank"
                                        className="app-google"
                                        href="https://play.google.com/store/apps/details?id=jp.co.saisoncard.android.saisonportal&hl=ja"
                                    >
                                        <img src={playstore} alt="play store" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </>
    );
}

export default Refill;
